import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface SimpleModeContextType {
  isSimpleMode: boolean;
  setSimpleMode: (enabled: boolean) => void;
  toggleSimpleMode: () => void;
}

const SimpleModeContext = createContext<SimpleModeContextType | undefined>(undefined);

export const SimpleModeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isSimpleMode, setIsSimpleMode] = useState(() => {
    return localStorage.getItem('agxl_simple_mode') === 'true';
  });

  useEffect(() => {
    localStorage.setItem('agxl_simple_mode', String(isSimpleMode));
    // Add class to document for CSS-based hiding
    if (isSimpleMode) {
      document.documentElement.classList.add('simple-mode');
    } else {
      document.documentElement.classList.remove('simple-mode');
    }
  }, [isSimpleMode]);

  const setSimpleMode = (enabled: boolean) => setIsSimpleMode(enabled);
  const toggleSimpleMode = () => setIsSimpleMode(prev => !prev);

  return (
    <SimpleModeContext.Provider value={{ isSimpleMode, setSimpleMode, toggleSimpleMode }}>
      {children}
    </SimpleModeContext.Provider>
  );
};

export const useSimpleMode = () => {
  const context = useContext(SimpleModeContext);
  if (!context) {
    throw new Error('useSimpleMode must be used within SimpleModeProvider');
  }
  return context;
};
